import { rect, px } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Hull } from '../../types';

export const dragon: Hull = {
  id: 'dragon',
  name: 'Dragon',
  baseStats: { ferocity: 35, agility: 15, arcane: 30, resilience: 20, stealth: 5 },
  drawBody: (ctx, p, t = 0) => {
    const frame = Math.floor((t * 4) % 2);
    // Body trunk
    rect(ctx, 14, 22, 32, 14, p.primary);
    rect(ctx, 14, 33, 32, 3, p.shadow);
    // Spine highlight
    rect(ctx, 16, 22, 28, 1, p.light);
    // Head
    rect(ctx, 4, 18, 12, 10, p.primary);
    rect(ctx, 4, 26, 12, 2, p.shadow);
    rect(ctx, 4, 18, 12, 1, p.light);
    // Snout (protruding left)
    rect(ctx, 0, 21, 4, 6, p.primary);
    rect(ctx, 0, 25, 4, 2, p.shadow);
    // Horns
    rect(ctx, 5, 14, 2, 4, p.metalDark);
    rect(ctx, 11, 14, 2, 4, p.metalDark);
    // Eye ridge accent + dark pupil + small detail spot
    px(ctx, 9, 21, p.accent);
    px(ctx, 10, 21, p.dark);
    px(ctx, 9, 20, p.detail);
    // Folded wings on back (visible silhouette, below the back anchor)
    rect(ctx, 24, 18, 14, 6, p.shadow);
    rect(ctx, 24, 18, 14, 1, p.dark);
    // Front legs
    rect(ctx, 18, 36, 5, 12, p.primary);
    rect(ctx, 18, 36, 1, 12, p.shadow);
    rect(ctx, 18, 48, 5, 2, p.dark);
    // Mid + rear legs (4-legged)
    rect(ctx, 28, 36, 5, 12, p.primary);
    rect(ctx, 28, 36, 1, 12, p.shadow);
    rect(ctx, 28, 48, 5, 2, p.dark);
    rect(ctx, 38, 36, 5, 12, p.primary);
    rect(ctx, 38, 36, 1, 12, p.shadow);
    rect(ctx, 38, 48, 5, 2, p.dark);
    // Tail (rightward, tapering)
    rect(ctx, 46, 26, 8, 4, p.primary);
    rect(ctx, 50, 28, 8, 2, p.primary);
    rect(ctx, 56, 28, 4, 2, p.shadow);
    // Snout breath wisp (frame 0 only)
    if (frame === 0) {
      px(ctx, 1, 22, p.glassLight);
      px(ctx, 0, 23, p.glassLight);
    }
  },
  mounts: {
    [SLOT.CRANIUM]: { anchor: { x: 14, y: 14 } },
    [SLOT.BACK]:    { anchor: { x: 30, y: 24 } },
    [SLOT.TAIL]:    { anchor: { x: 52, y: 32 } },
  },
};
